import { ActionTree } from "vuex";
import { baseApi } from "@/config/http-common";
import { IProcessUserState } from "@/store/modules/processUser/state";
import { IRootState } from "@/store";
import { ProcessUserMutations } from "@/store/modules/processUser/mutations";
import { AuthGetters } from "@/store/modules/auth";
import { accountKey } from "@/utils/accountSession";

export enum ProcessUserActions {
  FETCH_DATA_PROVIDER = "GET_DATA_PROVIDER_PROCESS_USER",
  FETCH_ONE = "GET_ONE_PROCESS_USER",
  CREATE = "CREATE_PROCESS_USER",
  UPDATE = "UPDATE_PROCESS_USER",
  DELETE = "DELETE_PROCESS_USER",
}

let listRequestSequence = 0;
export const actions: ActionTree<IProcessUserState, IRootState> = {
  async [ProcessUserActions.FETCH_DATA_PROVIDER](
    { commit, rootGetters },
    payload
  ) {
    const sequence = ++listRequestSequence;
    const account = accountKey(rootGetters[AuthGetters.GET_USER_IDENTITY]);
    const result = await baseApi.get("/documents/process-user/list", {
      params: payload,
    });
    if (
      sequence !== listRequestSequence ||
      account !== accountKey(rootGetters[AuthGetters.GET_USER_IDENTITY])
    )
      return;
    commit(ProcessUserMutations.SET_LAZY_DATA, result.data.data);
    return result.data.data;
  },
  async [ProcessUserActions.FETCH_ONE]({ commit }, id) {
    try {
      const result = await baseApi.get(`/documents/process-user/view/${id}`);
      commit(ProcessUserMutations.SET_ONE, result.data.data);
    } catch (error) {
      console.log("fetch process user one error: ", error);
    }
  },
  async [ProcessUserActions.CREATE]({ commit }, data: Document) {
    try {
      await baseApi.post("/documents/process-user", data);
    } catch (error) {
      console.log("process user create error: ", error);
    }
  },
  async [ProcessUserActions.UPDATE]({ commit }, payload) {
    try {
      await baseApi.put(`/documents/process-user/${payload.id}`, payload.data);
    } catch (error) {
      console.log("process user update error: ", error);
    }
  },
  async [ProcessUserActions.DELETE]({ commit }, id: string) {
    try {
      await baseApi.delete(`/documents/process-user/${id}`);
    } catch (error) {
      console.log("process user delete error: ", error);
    }
  },
  /*getConstructors(): Promise<any> {

        return  baseApi.get('/documents/document/sub-data/constructors')
    }

    getConstructorInfo(id: any): Promise<any> {
        return baseApi.get('/documents/document/sub-data/constructor-info', {params:{id: id}})
    }

    getNomenclatures(): Promise<any> {
        return baseApi.get('/documents/document/sub-data/nomenclatures')
    }

    getProcessUserFilter(data: any): Promise<any> {
        return baseApi.post('/documents/document/sub-data/process-user-filter', data)
    }

    getOneDocumentUpdateInfo(id: any): Promise<any> {
        return baseApi.get('/documents/document/sub-data/document-update-info',{ params:{id: id}})
    }

    uploadDocument(file: any): Promise<any> {
        return filemanagerApi.post('/upload', file,{headers:{'Content-Type': 'multipart/form-data' }})
    }

    getFilesInfo(file: any): Promise<any> {
        return filemanagerApi.post('/files-info', file)
    }

    returnDocument(id: any): Promise<any> {
        return baseApi.get(`/documents/document/return/${id}`)
    }

    sendForExecution(id: any): Promise<any> {
        return baseApi.get(`/documents/document/send-for-execution/${id}`)
    }

    getConstructorFilter(): Promise<any> {
        return baseApi.get(`/documents/document/filter-data/constructors`)
    }*/
};
